/* eslint-disable import/prefer-default-export */
import sendGaGtmEvent, {
  GA_GTM_EVENT_NAMES,
  GA_GTM_SEARCH,
} from "web/utils/system/GTM/sendGaGtmEvent";

export const trackSearchStart = (eventLabel: string) => {
  sendGaGtmEvent({
    gtmEventName: GA_GTM_EVENT_NAMES.SEARCH_START,
    eventCategory: GA_GTM_SEARCH.CATEGORY,
    eventAction: GA_GTM_SEARCH.START_ACTION,
    eventLabel,
  });
};
